export function normalizeUrl(url: string) {
  if (!/^https?:\/\//i.test(url)) {
    return 'https://' + url;
  }
  return url;
}

export function capitalizeIfUppercase(word: string) {
  if (!word) return '';
  if (word === word.toUpperCase()) {
    return word.charAt(0) + word.slice(1).toLowerCase();
  }
  return word;
}

export const extractParent = (client: any) => {
  if (!client) {
    return null;
  }

  const parent = client.parent;

  if (!parent?.billToParent) {
    return parent || null;
  }

  return extractParent(client.parent);
};

export const resolveItemBillingTypeClientBased = (client: any, item: any) => {
  if (!client || !item) {
    return {
      method: '',
      value: '',
    };
  }

  let tempClient = client;
  if (client?.billToParent) {
    tempClient = extractParent(client?.parent);
  }

  let billingObj = tempClient
    ? tempClient?.billToParent
      ? tempClient?.billingInfo || tempClient?.billingDetails
      : tempClient?.billingInfoDirectly || tempClient?.billingDetailsDirectly
    : client?.billToParent
      ? client?.billingInfo || client?.billingDetails
      : client?.billingInfoDirectly || client?.billingDetailsDirectly;

  let billingType = billingObj?.['billingType'];

  if (billingType === 'Trade') {
    return {
      method: item?.tradePricingMethod || '',
      value: item?.tradePricingValue || '',
    };
  } else if (billingType === 'Retail') {
    return {
      method: item?.retailPricingMethod || '',
      value: item?.retailPricingValue || '',
    };
  }
  return {
    method: '',
    value: '',
  };
};

export const calculateComponentPrice = (component: any, percentages: any = {}) => {
  const { value, type } = percentages;
  if (!component) return;

  const parsed_value = Number(value) || 0;
  const markup_or_discount = type === 'discount' ? -parsed_value : parsed_value;

  const qty = Number(component?.qty) || 1;
  const cost = Number(component?.cost) || 0;
  const markup = Number(component?.markup) || 0;

  const totalPercentage = 1 + markup / 100 + markup_or_discount / 100;

  let price = qty * cost * totalPercentage;

  return price.toFixed(2);
};

export const deepEqual = (a: any, b: any): boolean => {
  if (a === b) return true;

  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  if (typeof a !== 'object' || typeof b !== 'object' || !a || !b) {
    return false;
  }

  if (Array.isArray(a) !== Array.isArray(b)) return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!deepEqual(a[key], b[key])) return false;
  }

  return true;
};

export const addRemainingZeros = (value: string) => {
  if (!value) return '';

  if (value.endsWith('.')) {
    return '00';
  } else if (value?.split('.')?.[1]?.length === 1) {
    return '0';
  } else if (!value.includes('.')) {
    return '.00';
  }
  return '';
};

export const allowCTRL = (evt: any) => {
  if (!evt) return false;

  let allow = (evt.ctrlKey || evt.metaKey) && ['a', 'c', 'v', 'x'].includes(evt.key.toLowerCase());
  return allow;
};
